import * as types from './mutation-types'

export default {
  [types.SET_MY_INFO] (state, result) {
    Object.assign(state.myInfo, result)
    state.myInfo.orders = result.orders
  },
  [types.SET_CURRENT_COUPON] (state, result) {
    Object.assign(state.currentCoupon, result)
  },
  [types.DELETE_ORDER] (state, orders) {
    state.myInfo.orders = orders
  },
  [types.SET_FAQ] (state, faq) {
    state.faq = faq
  },
  [types.SET_USERNAME] (state, username) {
    state.userName = username
  },
  [types.REFUND_CHECK] (state, refund) {
    state.refund = refund
  }
}



// WEBPACK FOOTER //
// ./src/store/my/mutations.js